import { NgTemplateOutlet } from "@angular/common";
import { Component, computed, input, output } from "@angular/core";

import { BarView, entryAccessibleName } from "../timeline-layout";

/** Multi-day entry (build or vendor order) clipped to the visible window. */
@Component({
  selector: "lib-timeline-bar",
  imports: [NgTemplateOutlet],
  template: `
    @if (interactive()) {
      <button
        type="button"
        class="bar"
        [class]="barClass()"
        [style.--entry-color]="bar().entry.color"
        [class.bar-late]="bar().entry.late"
        [class.cont-left]="bar().continuesLeft"
        [class.cont-right]="bar().continuesRight"
        [class.is-selected]="selected()"
        [attr.aria-label]="accessibleName()"
        [attr.aria-pressed]="selected()"
        [title]="accessibleName()"
        (click)="selectEntry.emit(bar().entry.id)"
      >
        <ng-container [ngTemplateOutlet]="content" />
      </button>
    } @else {
      <span
        class="bar static"
        role="img"
        [class]="barClass()"
        [style.--entry-color]="bar().entry.color"
        [class.bar-late]="bar().entry.late"
        [class.cont-left]="bar().continuesLeft"
        [class.cont-right]="bar().continuesRight"
        [attr.aria-label]="accessibleName()"
        [title]="accessibleName()"
      >
        <ng-container [ngTemplateOutlet]="content" />
      </span>
    }
    <ng-template #content>
      @if (bar().entry.warn) {
        <svg
          class="warn"
          [class.caution]="bar().entry.warn === 'warning'"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M12 2 1 21h22L12 2zm1 15h-2v-2h2v2zm0-4h-2V9h2v4z" />
        </svg>
      }
      <span aria-hidden="true">{{ bar().continuesLeft ? "← " : "" }}{{ bar().text ?? bar().entry.label }}</span>
    </ng-template>
  `,
  styleUrl: "./timeline-bar.component.scss",
})
export class TimelineBar {
  readonly bar = input.required<BarView>();
  readonly selected = input(false);
  /** False draws the bar as a label only, for strips with nothing to open. */
  readonly interactive = input(true);
  readonly selectEntry = output<string>();

  protected readonly barClass = computed(() => `bar-${this.bar().entry.barStyle ?? "tint"}`);
  protected readonly accessibleName = computed(() => entryAccessibleName(this.bar().entry));
}
